<template>
  <div>
    <h3>We make good happen.</h3>

    <p>As the leading nonprofit software solution, Neon helps thousands of nonprofits raise more, save time, and get more done.</p>
  </div>
</template>

<script>
  export default {
    name: 'app'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/about/component/aboutUs.vue